module.exports = __webpack_public_path__ + "img/staff.abb2a0cf.svg";